import { useWindowDimensions } from '../../../utils'
import { useIntl } from 'react-intl'

import React from 'react'
import {
    renderBottomCenterControls,
    renderCenterLeftControls,
    renderCenterRightControls
} from '../carousel'
import { assets } from '../../assets/duels'
import styled from 'styled-components'
import CarouselElement from 'nuka-carousel'
import { media } from 'app/assets/styles'
import { TPKColors } from '../../../colors'
import { SPACING } from '../../../../../app-v2/design-tokens'

export function DuelsCarousel() {
    const { width: windowWidth } = useWindowDimensions()

    const intl = useIntl()
    return (
        <StyledCarouselContainer>
            <StyledCarousel
                adaptiveHeight
                renderCenterLeftControls={renderCenterLeftControls}
                renderCenterRightControls={renderCenterRightControls}
                renderBottomCenterControls={renderBottomCenterControls}
                slidesToShow={(Math.log(windowWidth) / Math.log(412)) * 1.5}
                wrapAround
                autoplayInterval={5000}
                autoPlay
                cellSpacing={24}>
                {assets.map((asset, i) => (
                    <StyledCarouselItem key={i}>
                        <StyledCarouselImg alt={'win'} src={asset} />
                    </StyledCarouselItem>
                ))}
            </StyledCarousel>
        </StyledCarouselContainer>
    )
}

const StyledCarouselImg = styled.img`
    object-fit: contain;
    max-height: 230px;
    width: 100%;
    padding-left: ${SPACING.XXXL};
`

const StyledCarouselContainer = styled.div`
    display: flex;
    background: ${TPKColors.carouselBlue};
    max-width: 1280px;
    ${media.medium`
        margin: 0 auto;
        box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.06);
        border-radius: 12px;
        width: calc(100% - 48px);
        padding: 48px 0 48px 0;
    `}
    padding: 48px 0 80px 0;
    align-self: center;
    justify-content: center;
    align-items: center;
    width: calc(100%);
`

const StyledCarouselItem = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 24px;
    max-height: 230px;
    box-sizing: border-box;
`

const StyledCarousel: typeof CarouselElement = styled(CarouselElement)`
    .slider-control-bottomcenter {
        ${media.medium`display: none`}
    }

    .slider-control-centerright,
    .slider-control-centerleft {
        display: none;
        ${media.medium`display: block`}
    }

    &:focus {
        outline: none;
    }

    .slider-frame::before {
        content: ' ';
        position: absolute;
        background: linear-gradient(
            90deg,
            ${TPKColors.carouselBlue}FF 5%,
            ${TPKColors.carouselBlue}00 20%,
            ${TPKColors.carouselBlue}00 80%,
            ${TPKColors.carouselBlue}FF 95%
        );
        z-index: 1;
        height: 100%;
        width: 100%;
    }
`
